"use client";

import qs from "qs";
import Image from "next/image";

export const PROXY_IMAGE_URL = "https://images.vnetwork.vn/resize"

const isSvg = (src: any) => {
  try {
    let paths = [];

    if (src.data) {
      paths = src.data?.attributes?.url?.split("/");
    } else {
      paths = src?.split("/");
    }

    if (new RegExp(/svg/g).test(paths[paths.length - 1])) return true;
  } catch (exception: any) {
    console.log(exception?.message, src);

    return false;
  }
};

function maginary({ src = "", aspectratio, quality = 75, ...props }: any) {
  if (isSvg(src)) return src;

  let defaultOptions = {
    aspectratio: undefined,
    width: props.scaleWidth || props.width,
    compression: 5,
    quality,
    url: src
  }

  if (aspectratio) {
    defaultOptions = {
      ...defaultOptions,
      aspectratio: aspectratio
    }
  }

  const query = qs.stringify(defaultOptions)

  return `${PROXY_IMAGE_URL}?${query}`;
}

export default function ImageMaginary({ src, ...props }: any) {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <Image
      {...props}
      src={src}
      unoptimized={isSvg(src)}
      loader={(prev) => maginary({ ...prev, ...props })}
    />
  );
}